angular.module('dpw.services')

    /**
     * StepManager Class
     *
     * @param {Array<Object>} stepsConfig                       - Configuration objects for all steps.
     * @param {String} stepsConfig[index].stepName              - ID for the step.
     * @param {String} stepsConfig[index].previousStepName      - Undefined if the step is the first.
     * @param {String} stepsConfig[index].nextStepName          - Undefined if the step is the last.
     * @param {Function} [stepsConfig[index].onStepBackward]    - Invoked before stepping backward to the previous step, and it receives a function `stepBackward` as parameter which should be executed when you want to step into the previous step.
     * @param {Function} [stepsConfig[index].onStepForward]     - Invoked before stepping forward to the next step, and it receives a function `stepForward` as parameter which should be executed when you want to step into the next step.
     * @param {Object} [componentCtrl]                          - Will be passed to `onStepBackward` and `onStepForward` as second parameter.
     *
     * @Example
     * $ctrl.stepManager = new StepManager(stepsConfig);
     */
    .factory('StepManager', [function () {
        var StepManager = function (stepsConfig, componentCtrl) {
            this.stepsConfig = stepsConfig;
            this.componentCtrl = componentCtrl;
            this._setCurrentStep(this.getFirstStepConfig().stepName);
        };

        _.assign(StepManager.prototype, {
            isStep: function (stepName) {
                return stepName === this._getCurrentStepName();
            },

            isFirstStep: function (stepName) {
                var stepConfig = this.getStepConfig(stepName);
                return !stepConfig.previousStepName;
            },

            isLastStep: function (stepName) {
                var stepConfig = this.getStepConfig(stepName);
                return !stepConfig.nextStepName;
            },

            stepForward: function () {
                var currentStepConfig = this.getStepConfig();
                this._navigateStepTo(currentStepConfig.nextStepName, 'onStepForward');
            },

            stepBackward: function () {
                var currentStepConfig = this.getStepConfig();
                this._navigateStepTo(currentStepConfig.previousStepName, 'onStepBackward');
            },

            getFirstStepConfig: function () {
                return _.find(this.stepsConfig, function (stepConfig) {
                    return _.isUndefined(stepConfig.previousStepName);
                });
            },

            /**
             * Get step configuration by name
             *
             * @param {String} [stepName]
             * @returns {Object} - If the step name is not given, the configuration for current step will be returned.
             */
            getStepConfig: function (stepName) {
                return _.find(this.stepsConfig, 'stepName', stepName || this._getCurrentStepName());
            },

            _navigateStepTo: function (expectedStepName, operationName) {
                var self = this;
                var currentStepConfig = self.getStepConfig();
                var onStepNavigation = _.get(currentStepConfig, operationName);

                if (_.isFunction(onStepNavigation)) {
                    onStepNavigation(function onSuccess() {
                        self._setCurrentStep(expectedStepName);
                    }, self.componentCtrl);
                } else {
                    self._setCurrentStep(expectedStepName);
                }
            },

            _getCurrentStepName: function () {
                return this.currentStepName;
            },

            _setCurrentStep: function(stepName) {
                this.currentStepName = stepName;
            }
        });

        return StepManager;
    }])

;